export const PaymentMethod = {
  CASH: "Espèces",
  CARD: "Carte",
  SPLIT_PAYMENT: "À crédit",
  CHECKS_PAYMENT: "Chèque",
};

export const getPaymentMethodsOptions = (exclude = []) => {
  return Object.entries(PaymentMethod)
    .filter(([key]) => !exclude.includes(key))
    .map(([key, label]) => ({
      value: key,
      label,
    }));
};